module.exports = __webpack_public_path__ + "static/Squat-it-4e84178de166d9ae98eeaa9b11d067c0.webm";